import heroRoom from './../assets/images/Weddings/heroRoom.jpg'

const WeddingHero = () => {
  const scrollToContactForm = () => {
    const contactForm = document.getElementById('ContactForm');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='w-full h-[90vh] relative mb-16'>
      <div className="absolute top-0 left-0 w-full h-[90vh] bg-cover lg:bg-fixed md:bg-fixed" style={{
          backgroundImage: `url(${heroRoom})`,
          backgroundPosition: 'center'
        }} />
      <div className="absolute inset-0 bg-black opacity-40"/>
      <div className='bg-black/30 absolute top-0 left-0 w-full h-[90vh] z-10'/>
        <div className='absolute top-16 w-full h-full flex flex-col justify-center text-white text-center z-20'>
            <div className='md:left-[10%] md:right-[10%] max-w-[1100px] m-auto absolute p-4'>
                <div className='flex justify-center'>
                    <h1 className='font-bold text-5xl md:text-7xl drop-shadow-2xl'>Your Wedding at The Fox</h1>
                </div>
                <p className='drop-shadow-2xl py-4 text-xl'>Our beautiful function suite, complete with a private bar, stage area, and adjoining sun terrace, is available exclusively for you. The suite can accommodate up to 100 guests for your ceremony and up to 160 for your evening event. The venue hire includes a full ceremony setup and colour-coordinated chair décor to match your theme.</p>
                <button onClick={scrollToContactForm} className='bg-white text-black border-2 border-black px-4 py-1 rounded-full font-bold hover:bg-black hover:text-white transition-all duration-300'>Book A Viewing</button>
            </div>
        </div>
    </div>
  )
}

export default WeddingHero
